var render = function (_h,_vm) {var _c=_vm._c;return _c('router-link',{class:_vm.data.staticClass,attrs:{"to":{
    name: _vm.props.name,
    params: _vm.props.params,
    query: _vm.props.query,
    to: _vm.props.to,
  },"exact":_vm.props.exact,"tag":_vm.props.tag,"target":_vm.props.newTab ? '_blank' : false}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }